import React from 'react';
import styles from './logo.module.scss';
import { useNavigate } from 'react-router-dom';
import { userStore } from 'entities/index';

export const Logo: React.FC = () => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    userStore.redirectToRoleBasedPage(navigate);
  };

  return (
    <div className={styles.logo} onClick={handleLogoClick}>
      <span className={styles.logo__gray}>Book</span>
      <span className={styles.logo__green}>Up</span>
    </div>
  );
};
